<template>
  <v-container fluid>
    <page-header>
      <template slot="topRightSlot">
        <v-btn depressed elevation="0" class="ml-2 mb-4" color="primary" type="button" :to="{ name: 'CreatePlan' }">{{
          $t('add')
        }}</v-btn>
      </template>
    </page-header>

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      actionViewRouteLink="PlanDetail"
      @options-update="getList()"
      enableClearAll
      @all-search-cleared="clearSearch()"
      disablePagination
    >
      <template slot="custom-toolbar-slot">
        <form-select
          :fieldValue.sync="tableFilter.type"
          hideDetails
          dense
          placeholder="searchType"
          :options="$planTypeOptions"
          class="mr-3 mt-2 mb-3"
          enabledClear
          @changed="search()"
        />
      </template>
      <template v-slot:[`item.type`]="{ item }">{{ item.type | formatPlanType }}</template>
      <template v-slot:[`item.company_type`]="{ item }">{{ item.company_type | formatCompanyType }}</template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/form/FormSelect.vue'
export default {
  name: 'PlanList',
  components: {
    Datatable,
    FormSelect,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
      type: '',
    },
    tableHeaders: [
      { value: 'id', text: 'ID' },
      { value: 'type', text: vm.$t('planType') },
      { value: 'company_type', text: vm.$t('companyType') },
      { value: 'name', text: vm.$t('planName') },
      { value: 'price_display', text: vm.$t('price') },
      { value: 'price_display_text', text: vm.$t('displayPriceZh') },
      { value: 'status', text: vm.$t('status') },
      { value: 'actionView', text: '', align: 'end' },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = {
          filters: [],
        }

        if (this.tableFilter.type) {
          payload.filters.push({ key: 'type', value: this.tableFilter.type })
        }
        const { total, data } = await this.$Fetcher.GetPlans(payload)
        this.tableTotal = total
        this.tableData = data.map(item => {
          return {
            id: item.id,
            type: item.type,
            company_type: item.company_type,
            name: `${item.name_zh}\n${item.name_en}`,
            price_display: `HK$${this.$Formatter.separator(item.price)}`,
            price_display_text: item.display_price_zh,
            status: item.status
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },
    search() {
      this.tableFilter.page = 1
      this.getList()
    },
    clearSearch() {
      this.tableFilter.type = ''
      this.tableFilter.page = 1
      this.getList()
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }

        if (this.$validate.DataValid(query.type)) {
          this.tableFilter.type = query.type
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
        type: this.tableFilter.type || null,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
